import { Divider } from 'antd';
import HeroSection from './HeroSection';
import ProjectsSection from './ProjectsSection';
import VideoSection from './VideoSection';
import './HomePage.css';

const HomePage = () => (
  <>
    <HeroSection />
    <Divider className="section-divider" />
    <VideoSection />
    <Divider className="section-divider" />
    <ProjectsSection />
  </>
);

export default HomePage;
